import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'

/*** helpers ***/
import {ItemTypes} from "../BuildsComponent/ItemsTypes";

/*** images ***/
import imgSrcAusparung from '../../../../image/aussparung.png';

class SourceLidDnD extends  Component {
    componentDidMount() {
        // Use empty image as a drag preview so browsers don't draw it
        // and we can draw whatever we want on the custom drag layer instead.
        this.props.connectDragPreview(getEmptyImage(), {
            // IE fallback: specify that we'd rather screenshot the node
            // when it already knows it's being dragged so we can hide it with CSS.
            captureDraggingState: true,
        })
    }
    render() {
        const style = {
            width : "100%",
            height : "100%",
            display: "block",
            ...this.props.style
        };
        const indexStyle = {
          color: !this.props.value ? "#ffffff" : "#000000",
          fontSize : "18px",
            paddingLeft: "10px",
            paddingTop: "10px"
        };
        if(this.props.withoutDragging){
            return (this.props.value ?
                <div id = {this.props.id}  className={`lid-icon-hatching-step-2 size-for-480 ${this.props.sourceClass}`} style = {style}>
                    <div style = {indexStyle}>{this.props.index + 1}</div>
                </div> :
                <div id = {this.props.id} className={`lid-icon-hatching-step-2 size-for-480 ${this.props.sourceClass}`} style={{...style}}>
                    <div style = {{position: "absolute", ...indexStyle}}>{this.props.index + 1}</div>
                    <img src={imgSrcAusparung}  style = {{width: "100%", height: "100%", display : "block"}} alt={"ausparung_sagex"}/>
                </div>);
        }

        return this.props.connectDragSource(this.props.value ?
            <div id = {this.props.id}  className={`lid-icon-hatching-step-2 size-for-480 ${this.props.sourceClass}`} style = {style}>
                <div style = {indexStyle}>{this.props.index + 1}</div>
            </div> :
            <div id = {this.props.id} className={`lid-icon-hatching-step-2 size-for-480 ${this.props.sourceClass}`} style={{...style}}>
                <div style = {{position: "absolute", ...indexStyle}}>{this.props.index + 1}</div>
                <img src={imgSrcAusparung}  style = {{width: "100%", height: "100%", display : "block"}} alt={"ausparung_sagex"}/>
            </div>)
    }
}


SourceLidDnD.propTypes = {
  value : PropTypes.bool
};
const sourceLid =  {
    beginDrag(props){
        return{
            index : props.index,
            currentStep : props.currentStep,
            sagex : props.value,
            isPlan : props.isPlan,
            widthoutDragging : props.withoutDragging
        };
    }
};
const collect = (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
});

export default  DragSource(ItemTypes.LID, sourceLid, collect)(SourceLidDnD)


// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/OptionsArea/SourceLidDnD.js